import { Pagination } from "../types/api/generic.type";

export const checkHasMoreData = ({
  total,
  pageNumber,
  pageSize,
}: Pagination): boolean => (pageNumber + 1) * pageSize < total;
